import { Primary } from './color-palette/colors';

export const FOCUS_RING_WIDTH = 2;
export const FOCUS_RING_OFFSET = 2;
export const focusRing = (color: string = Primary[500]): string => `${FOCUS_RING_WIDTH}px solid ${color}`;
export const FOCUS_RING = focusRing();
